 export default function getBioData () {
   let bioInfo = localStorage.getItem('bioInfo')
    
    if(!bioInfo){
      return null
    }
    
    try {
      bioInfo = JSON.parse(bioInfo) 
    } catch (error) {
      bioInfo = null
    }

    return bioInfo
  }

  export function formatDate (date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }